import React from "react";

import strings from "../../utils/strings";

interface FooterPropsI {
	continueShopping: () => void;
	goToCart: () => void;
}

export const Footer = ({ continueShopping, goToCart }: FooterPropsI) => {
	return (
		<footer className="addtocart-popup__footer">
			<button
				className="addtocart-button btn btn-large tertiary-grey close-addtocart"
				data-testid="footer-button-continue"
				onClick={continueShopping}
			>
				<span className="hidden-xs hidden-sm">{strings.continueShopping}</span>
				<span className="hidden-md hidden-lg">
					{strings.continueShoppingShort}
				</span>
			</button>
			<button
				className="addtocart-button btn btn-large primary goto-cart"
				data-testid="footer-button-gotocart"
				onClick={goToCart}
			>
				<span className="hidden-xs hidden-sm">{strings.goToCart}</span>
				<span className="hidden-md hidden-lg">{strings.goToCartShort}</span>
			</button>
		</footer>
	);
};

